<script setup>
import HauptMenue from "../../components/HauptMenue.vue";
import FooterMenu from "../../components/FooterMenu.vue";
import DatenschutzHinweis from "../../components/DatenschutzHinweis.vue";
import DateInput from "../../components/DateInput.vue";
import ButtonSendDataSelfService from "../../components/ButtonSendDataSelfService.vue";
import ButtonResetServiceData from "../../components/ButtonResetServiceData.vue";
import CustomSelect from "../../components/CustomSelect.vue";
import Alertbox from "../../components/Alertbox.vue";
import ButtonBack from "../../components/ButtonBack.vue";
import { store } from "../../components/store.vue";
import { onMounted } from "vue";
import { ersterDesFolgemonats, diffObj } from "../../utility";

/** View-Komponente zum Erfassen von Aufträgen zur Beitragsfreistellung
 * @displayName Selfservice Auftrag Beitragsfreistellung
 */
onMounted(() => {
  // options with default values
  /*
  const options = {
    placement: "top",
    triggerType: "hover",
  };
  */
  // instance options with default values
});
</script>
<script>
export default {
  name: "SelfServiceBeitragsfreistellung",

  components: {
    // myRouter: router,
    HauptMenue,
    FooterMenu,
    DatenschutzHinweis,
    DateInput,
    ButtonSendDataSelfService,
    ButtonResetServiceData,
    CustomSelect,
    Alertbox,
    ButtonBack,
  },
  data() {
    return {
      store,
      saved: false,
      sPMNROptions: this.$servertalk.getVbPMNROpts(
        store.selfService.Beitragsfreistellung.ident
      ),
      sVersNrOptions: this.$servertalk.getVERSNROpts(
        store.selfService.Beitragsfreistellung.ident
      ),
      sGrundOptions: this.$servertalk.getSelectOpts("BTGFREIGRND"),
      sGesellschaftsformOptions: this.$servertalk.getSelectOpts("GESFORM"),
      abDatumOk:
        store.subData.draft.sService.Entwuerfe.Beitragsfreistellung?.GUELTIGAB ? store.subData.draft.sService.Entwuerfe.Beitragsfreistellung?.GUELTIGAB.length == 10 : false,
      letzteZahlungOk:
        store.subData.draft.sService.Entwuerfe.Beitragsfreistellung?.LETZTE_ZAHLUNG ? store.subData.draft.sService.Entwuerfe.Beitragsfreistellung?.LETZTE_ZAHLUNG.length == 10 : false,
      draftOrigin: null,
      draftChanged: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window._paq.push(["setDocumentTitle", this.name]);
    window._paq.push(["trackPageView"]);
  },
  unmounted() {
    if (this.saved) {
      // Nach Beauftragung Service in Draft komplett löschen
      delete store.subData.olddraft.sService.Entwuerfe.Beitragsfreistellung;
      delete store.subData.draft.sService.Entwuerfe.Beitragsfreistellung;
      this.saved = false;
    }
  },
  beforeCreate: function () {
    this.$servertalk.doLog("Create");
    this.$servertalk.doLog("Inhalt store:");
    this.$servertalk.doLog(store);
    let action = this.$servertalk.initSelfService(
      "Beitragsfreistellung",
      '{"APANSPRNR":"", "PERSNR":"", "Vorname":"", "Nachname":"", "PMNR":"", "VERSNR":"","GUELTIGAB":"","LETZTE_ZAHLUNG":"", "GRUND":"", "BEMERKUNG":"", "uuid":"", "version":"1.3"}',
      "1.3",
      store.subData
    );
    // Ermitteln des Index des aktuellen Mitarbeiters in subData
    this.Mitarbeiter = store.xSelectedMitarbeiter;
    //if (action % 2 == 1) {
    // olddraft wurde initialisiert
    this.$servertalk.doLog("olddraft wurde initialisiert");

    let olddraft =
      store.subData.olddraft.sService.Entwuerfe.Beitragsfreistellung;
    olddraft.PERSNR = store.xSelectedMitarbeiter.PERSNR;
    olddraft.uuid = this.$servertalk.getUUID();

    //if (action >= 2) {
    this.$servertalk.doLog("draft wurde initialisiert");
    // draft wurde initialisiert
    this.$servertalk.copyToDraftSelfService(
      "Beitragsfreistellung",
      store.subData
    );
    //console.log('#Draft', store.subData.draft.sService.Entwuerfe)
    //  }
  },
  created: function () {
    // Erforderlich für Anzeige von Änderungsaufträgen.
    let draft = store.subData.draft.sService.Entwuerfe.Beitragsfreistellung;
    draft.GRUND = this.sGrundOptions[0].value; // Der Grund ist im Dropdown voreingestellt und soll immer als Änderung gespeichert werden.
    draft.APANSPRNR = store.masterData.data.Stammdaten.ANSPRNR;
    draft.GUELTIGAB = ersterDesFolgemonats();
    draft.LETZTE_ZAHLUNG = ersterDesFolgemonats();
    draft.Vorname = this.Mitarbeiter.VORNAME;
    draft.Nachname = this.Mitarbeiter.NAME;
    let _PMNR = this.$servertalk.getVbPMNR(
      store.selfService.Beitragsfreistellung.ident
    );
    draft.PMNR = "-"; // Es existiert keine PMNR
    draft.VERSNR = "-"; // Es existiert keine VERSNR
    if (_PMNR.length > 0) {
      draft.PMNR = _PMNR[0].PMNR; // Es existiert mindestens eine PMNR > die erste einstellen
      this.sVersNrOptions = this.$servertalk.getVERSNROpts(
        store.selfService.Beitragsfreistellung.ident,
        draft.PMNR
      );
      let _VERSNR = this.$servertalk.getVersicherungen(
        store.selfService.Beitragsfreistellung.ident,
        draft.PMNR
      );
      if (_VERSNR.length > 1) draft.VERSNR = _VERSNR[1].VERSNR; // Es existiert (genau) eine VERSNR > diese einstellen
      if (_VERSNR.length > 2) draft.VERSNR = _VERSNR[0].VERSNR; // Es existieren mehrere VERSNRn > "alle" einstellen
    }
    this.draftOrigin = structuredClone(draft);
  },
  methods: {
    draftModified(oldData, draft) {
      this.draftChanged = false;
      if (typeof oldData != "undefined") {
        const dif = diffObj(this.draftOrigin, draft);
        this.draftChanged = Object.keys(dif).length > 0;
        this.$servertalk.doLog('dif: >>>', dif);
      }
    },
    abDatumChecked(val) {
      this.abDatumOk = val == "false" ? true : false;
    },
    letzteZahlungChecked(val) {
      this.letzteZahlungOk = val == "false" ? true : false;
    },
    setGrund(val) {
      if (val && typeof val === "object" && typeof val.value !== "undefined") {
        store.subData.draft.sService.Entwuerfe.Beitragsfreistellung.GRUND =
          val.value + "";
        //this.$forceUpdate(); // Erzwingt ein erneutes Rendern der Komponente
      }
    },
    setPMNR(val) {
      let draft = store.subData.draft.sService.Entwuerfe.Beitragsfreistellung
      if (val && typeof val === "object" && typeof val.value !== "undefined") {
        draft.PMNR =
          val.value + "";
        //this.$forceUpdate(); // Erzwingt ein erneutes Rendern der Komponente
        this.sVersNrOptions = this.$servertalk.getVERSNROpts(
          store.selfService.Beitragsfreistellung.ident,
          draft.PMNR
        );
        let _VERSNR = this.$servertalk.getVersicherungen(
          store.selfService.Beitragsfreistellung.ident,
          draft.PMNR
        );
        if (_VERSNR.length == 2) {
          draft.VERSNR = _VERSNR[1].VERSNR; // Es existiert (genau) eine VERSNR > diese einstellen
        }
        if (_VERSNR.length > 2)
          draft.VERSNR = _VERSNR[0].VERSNR; // Es existieren mehrere VERSNRn > "alle" einstellen
        this.setVersicherungsnummer({ value: draft.VERSNR });
      }
    },
    setVersicherungsnummer(val) {
      if (val && typeof val === "object" && typeof val.value !== "undefined") {
        store.subData.draft.sService.Entwuerfe.Beitragsfreistellung.VERSNR =
          val.value + "";
      }
    },
    sendDataFinished() {
      let messageCode = this.$servertalk.sendDataSelfService(
        "Beitragsfreistellung",
        store.subData
      );
      store.message =
        messageCode == 0
          ? {
            text: "Ihre Änderungen im Bereich\n Beitragsfreistellung/entgeltfreie Zeit \n wurden erfolgreich beauftragt.",
            status: "ok",
          }
          : {
            text:
              "Beim Speichern des Auftrags im Bereich\n Beitragsfreistellung/entgeltfreie Zeit \n trat ein Fehler auf (Error-Code " +
              messageCode +
              ").",
            status: "error",
          };
      if (messageCode == 0) this.saved = true;
      this.$router.push("/mitarbeiterdaten");
    },
    resetData() {
      //this.$refs.SelectFamStand.reset(); // Zurücksetzen Select
      let messageCode = this.$servertalk.copyToDraftSelfService(
        "Beitragsfreistellung",
        store.subData
      );
      this.draftOrigin = structuredClone(store.subData.draft.sService.Entwuerfe.Beitragsfreistellung);
      store.message =
        messageCode == 0
          ? {
            text: "Ihre Änderungen im Bereich\n Beitragsfreistellung/entgeltfreie Zeit \n wurden zurückgesetzt.",
            status: "ok",
          }
          : {
            text:
              "Beim Zurücksetzen der Daten im Bereich\n Beitragsfreistellung/entgeltfreie Zeit \n trat ein Fehler auf (Error-Code " +
              messageCode +
              ").",
            status: "error",
          };
    },
  },
  watch: {
    "store.subData.draft.sService.Entwuerfe.Beitragsfreistellung": {
      handler(newData, oldData) {
        this.draftModified(
          oldData,
          store.subData.draft.sService.Entwuerfe.Beitragsfreistellung
        );
      },
      deep: true,
    },
  },
  computed: {
    getVersBeginn() {
      let dateVersBeg = false;
      let versNr =
        store.subData.draft.sService.Entwuerfe.Beitragsfreistellung.VERSNR;
      let versNrn = this.$servertalk.getVERSNROpts(
        store.selfService.Beitragsfreistellung.ident,
        store.subData.draft.sService.Entwuerfe.Beitragsfreistellung.PMNR
      );
      let idxVersnr = versNrn.findIndex((nr) => nr.text == versNr);
      if (idxVersnr >= 0) {
        let _VERSNR = this.$servertalk.getVersicherungen(
          store.selfService.Beitragsfreistellung.ident,
          store.subData.draft.sService.Entwuerfe.Beitragsfreistellung.PMNR
        );
        dateVersBeg = _VERSNR[idxVersnr].VERSBEG;
        /*
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        today = yyyy + '-' + mm + '-' + dd;
        */
        var today = 0;
      }
      return today > dateVersBeg ? today : dateVersBeg;
    },

    setSchwebendClass() {
      // Erhalte den Wert "Privatadresse" von $servertalk
      //const aenderung = this.$servertalk.gettAttr("fadata.Firmenstammdaten");
      //const aenderungPrivatadresseValue = this.$servertalk.gettAttr("subData.draft.sService.Entwuerfe.AenderungKontaktdaten");
      return null;
    },
    setStatusClass() {
      // Erhalte den Wert "Beitragsfreistellung" von $servertalk
      const AenderungBeitragsfreistellungdatenValue = this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Beitragsfreistellung"
      );
      return AenderungBeitragsfreistellungdatenValue;
    },
    setStatusClassPMNR() {
      // Erhalte den Wert "PMNR" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Beitragsfreistellung.PMNR"
      );
    },
    setStatusClassVERSNR() {
      // Erhalte den Wert "VERSNR" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Beitragsfreistellung.VERSNR"
      );
    },
    setStatusClassGRUND() {
      // Erhalte den Wert "GRUND" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Beitragsfreistellung.GRUND"
      );
    },
    setStatusClassBEMERKUNG() {
      // Erhalte den Wert "BEMERKUNG" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Beitragsfreistellung.BEMERKUNG"
      );
    },

    setStatusClassGUELTIGAB() {
      // Erhalte den Wert "GUELTIGAB" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Beitragsfreistellung.GUELTIGAB"
      );
    },
    setStatusClassLETZTE_ZAHLUNG() {
      // Erhalte den Wert "LETZTE_ZAHLUNG" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Beitragsfreistellung.LETZTE_ZAHLUNG"
      );
    },
    combinedFirmenstammdaten() {
      // Kombiniert FKENNR und FABRGR aus dem Store und trennt mit "/"
      const { FKENNR, FABRGR } = store.subData.data.Firmenstammdaten;
      return `${FKENNR || ""}/${FABRGR || ""}`;
    },
    versNrValid() {
      const val =
        this.store.subData.draft.sService.Entwuerfe.Beitragsfreistellung.VERSNR;
      return val && val !== "" && val !== "Bitte auswählen";
    },
  },
};
</script>
<template>
  <div class="main-wrapper" :class="store.accessRestriction">
    <HauptMenue />
    <div>
      <div class="mt-36 md:mt-48 lg:mt-56 max-w-7xl mx-auto">
        <div class="max-w-5xl mx-auto mb-8 px-5 lg:px-0">
          <h1 class="text-primary/75 font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl text-center mb-12 uppercase">
            Antrag auf
            <br />
            Beitragsfreistellung/entgeltfreie Zeit
            <br />
            <span v-if="false">
              "{{ store.subData.data.Firmenstammdaten.FNAME }}
              {{
                $servertalk.getName(
                  "GESFORM",
                  store.subData.data.Firmenstammdaten?.FGESFORM
                )
              }}
              {{ store.subData.data.Firmenstammdaten.FKENNR }}/{{
                store.subData.data.Firmenstammdaten.FABRGR
              }}"
            </span>

            <span>
              <h2 class="text-primary/75 font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-12">
                {{ store.xSelectedMitarbeiter.VORNAME }}
                {{ store.xSelectedMitarbeiter.NAME }}
              </h2>
            </span>
          </h1>
          <!--modal content-->
          <Alertbox />
          <div class="status-label mb-8" v-if="setStatusClass === 'modified'">
            <span class="bearbeitung bg-yellow-400 text-tertiary inline-block py-1 px-2 text-sm uppercase mb-2">
              Entwurf
            </span>
            <span class="infotext text-tertiary text-sm block">
              Dies ist ein Entwurf. Bitte bestätigen Sie diesen
              Änderungsauftrag, indem Sie unten auf
              <strong>Beauftragen</strong>
              klicken.
            </span>
          </div>
          <form :class="setStatusClass">
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-6">
                <div v-if="sPMNROptions.length > 1">
                  <CustomSelect @input="setPMNR" class="select" :class="setStatusClassPMNR" required label="PMNR"
                    :options="sPMNROptions" :default="store.subData.draft.sService.Entwuerfe.Beitragsfreistellung.PMNR"
                    :oldDefault="store.subData.olddraft?.sService.Entwuerfe.Beitragsfreistellung.PMNR" hideReset="false"
                    useArrowIcon="true" placeholder="Keine" />
                </div>
                <div v-else>
                  <label for="fixPMNR" class="text-sm mb-2 block">PMNR</label>
                  <input id="fixPMNR"
                    class="w-full p-3 border rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 border-secondary/50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                    :class="setStatusClassPMNR" type="text" v-model="store.subData.draft.sService.Entwuerfe
                      .Beitragsfreistellung.PMNR
                      " disabled />
                </div>
              </div>
              <div class="relative lg:col-span-6">
                <div v-if="sVersNrOptions.length > 2">
                  <CustomSelect @input="setVersicherungsnummer" class="select" :class="setStatusClassVERSNR"
                    inputClass="border-red-500" label="Versicherungsnummer" id="versicherungsnummer" required
                    :options="sVersNrOptions"
                    :default="store.subData.draft.sService.Entwuerfe.Beitragsfreistellung.VERSNR"
                    :oldDefault="store.subData.olddraft?.sService.Entwuerfe.Beitragsfreistellung.VERSNR"
                    hideReset="false" useArrowIcon="true" placeholder="Keine" />
                </div>
                <div v-else>
                  <label for="fixVERSNR" class="text-sm mb-2 block">
                    Versicherungsnummer
                  </label>
                  <input id="fixVERSNR"
                    class="w-full p-3 border rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 border-secondary/50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                    :class="setStatusClassVERSNR" type="text"
                    v-model="store.subData.draft.sService.Entwuerfe.Beitragsfreistellung.VERSNR" disabled />
                </div>
              </div>
            </div>
            <div class="grid lg:grid-cols-12 sm:gap-5">
              <div class="relative lg:col-span-6">
                <label for="aendVorname" class="text-sm mb-2 block">
                  Vorname der versicherten Person
                </label>
                <input maxlength="100" type="text" id="aendVorname"
                  class="peer w-full p-3 border border-secondary/50 rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                  v-model="store.xSelectedMitarbeiter.VORNAME" disabled="true" />
              </div>
              <div class="relative lg:col-span-6">
                <label for="aendName" class="text-sm mb-2 block">
                  Name der versicherten Person
                </label>
                <input maxlength="100" type="text" id="aendName"
                  class="peer w-full p-3 border border-secondary/50 rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                  v-model="store.xSelectedMitarbeiter.NAME" disabled="true" />
              </div>
            </div>
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-6">
                <label for="aendGueltigAb" class="text-sm mb-2 block">
                  Die Änderung ist gültig ab:
                  <sup>*</sup>
                </label>
                <DateInput :statusClass="setStatusClassGUELTIGAB" name="aendGueltigAb" id="aendGueltigAb"
                  placeholder="gültiges Datum" :required="true" :disabled="false" :dmin="getVersBeginn" dmax="+730"
                  :forceFirstOfNextMonth="true" v-model="store.subData.draft.sService.Entwuerfe.Beitragsfreistellung
                    .GUELTIGAB
                    " @dateChecked="abDatumChecked" :class="{ invalid: !abDatumOk }" />
              </div>
              <div class="relative lg:col-span-6">
                <label for="aendLetzteZahlung" class="text-sm mb-2 block">
                  Letzte Beitragszahlung erfolgt für den Monat:
                  <sup>*</sup>
                </label>
                <DateInput :statusClass="setStatusClassLETZTE_ZAHLUNG" name="aendLetzteZahlung" id="aendLetzteZahlung"
                  placeholder="gültiges Datum" :required="true" :disabled="false" :dmin="getVersBeginn" dmax="+730"
                  :forceFirstOfNextMonth="true" v-model="store.subData.draft.sService.Entwuerfe.Beitragsfreistellung
                    .LETZTE_ZAHLUNG
                    " @dateChecked="letzteZahlungChecked" :class="{ invalid: !letzteZahlungOk }" />
              </div>
            </div>
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-12">
                <CustomSelect @input="setGrund" class="select" label="Grund" id="grund" :required="true"
                  :class="setStatusClassGRUND" :options="sGrundOptions" :default="store.subData.draft.sService.Entwuerfe.Beitragsfreistellung
                    .GRUND
                    " :oldDefault="store.subData.olddraft.sService.Entwuerfe
                      .Beitragsfreistellung.GRUND
                      " placeholder="Keine" hideReset="false" useArrowIcon="true" />
              </div>
            </div>
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-12">
                <label for="aendBemerkung" class="text-sm mb-2 block">
                  Bemerkung
                </label>
                <textarea id="aendBemerkung"
                  class="w-full p-3 border border-secondary/50 rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 focus:outline-0 focus:border-tertiary/50 peer invalid:text-red-500 focus:invalid:border-red-500"
                  :class="setStatusClassBEMERKUNG" rows="5" v-model="store.subData.draft.sService.Entwuerfe.Beitragsfreistellung
                    .BEMERKUNG
                    "></textarea>
              </div>
            </div>
            <div class="button-wrapper flex justify-center gap-4 [&>button]:mx-0">
              <ButtonSendDataSelfService :disabled="store.subData.isReadOnly || !abDatumOk || !versNrValid
                " @finished="sendDataFinished" />
            </div>
          </form>
          <ButtonBack :confirm="draftChanged" />
          <DatenschutzHinweis />
        </div>
      </div>
    </div>

    <FooterMenu />
  </div>
</template>
